import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './SettingsManager.css';
import Sidebar from '../components/Sidebar';

interface Settings {
  id: number;
  siteTitle: string;
  logo: string;
  stripeKey: string;
  razorpayKey: string;
  paypalKey: string;
  deliveryCharge: number;
  freeShippingMin: number;
}

const SettingsManager: React.FC = () => {
  const [settings, setSettings] = useState<Settings>({
    id: 1,
    siteTitle: '',
    logo: '',
    stripeKey: '',
    razorpayKey: '',
    paypalKey: '',
    deliveryCharge: 0,
    freeShippingMin: 0,
  });

  useEffect(() => {
    axios.get('http://localhost:5000/settings/1')
      .then(res => setSettings(res.data))
      .catch(err => console.error(err));
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: name.includes("Charge") || name.includes("Min") ? Number(value) : value
    }));
  };

  const handleLogoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setSettings(prev => ({ ...prev, logo: imageURL }));
    }
  };

  const handleSave = () => {
    axios.put(`http://localhost:5000/settings/1`, settings)
      .then(() => alert("Settings saved successfully!"))
      .catch(err => console.error(err));
  };
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div style={{ display:'flex'}}>  <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
    <div
      style={{
        flex: 1,
        marginLeft: isSidebarOpen ? "250px" : "60px",
        transition: "margin-left 0.3s ease",
        padding: "20px"
      }}
    >
            <div className='main-content1'>

    <div className="settings-container">
      <h2>Settings</h2>

      <h3>General Settings</h3>
      <input type="text" name="siteTitle" value={settings.siteTitle} onChange={handleChange} placeholder="Site Title" />
      <input type="file" onChange={handleLogoUpload} />
      {settings.logo && <img src={settings.logo} alt="Logo" className="logo-preview" />}

      <h3>Payment Gateway Settings</h3>
      <input type="text" name="stripeKey" value={settings.stripeKey} onChange={handleChange} placeholder="Stripe Key" />
      <input type="text" name="razorpayKey" value={settings.razorpayKey} onChange={handleChange} placeholder="Razorpay Key" />
      <input type="text" name="paypalKey" value={settings.paypalKey} onChange={handleChange} placeholder="PayPal Key" />

      <h3>Delivery Settings</h3>
      <input type="number" name="deliveryCharge" value={settings.deliveryCharge} onChange={handleChange} placeholder="Delivery Charge" />
      <input type="number" name="freeShippingMin" value={settings.freeShippingMin} onChange={handleChange} placeholder="Free Shipping Minimum" />

      <button onClick={handleSave}>Save Settings</button>
    </div>
    </div></div></div>
  );
};

export default SettingsManager;
